import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './QRCode.module.scss';

export const QRCode = pixelTesterUrl => {
    return (
        <div className={styles['qr-container']}>
            <QRCodeCanvas value={pixelTesterUrl.pixelTesterUrl} size={171} minVersion={13} />
            <div className={styles['desktop-option-container']}>
                <FormattedMessage id="pixel.tester.qr-code.desktop-message" defaultMessage="Prefer a desktop option?" />
                <a href={pixelTesterUrl.pixelTesterUrl} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage
                        id="pixel.tester.qr-code.desktop-option.button"
                        defaultMessage="Click to open site"
                    />
                </a>
            </div>
        </div>
    );
};
